import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { Apitoken, Authtoken } from "../Global";
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION, AWS_BUCKET } from "../Global";

const ViewCustomer = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [permission, setPermission] = useState({});

  useEffect(() => {
    setPermission(FindModuleById(2));
    console.log(permission);



    axios
      .get(`/customers/view/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.user);

        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  if (value.company_logo) {
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
      accessKeyId: AWS_ACCESS_KEY_ID,
      secretAccessKey: AWS_SECRET_ACCESS_KEY,
      region: AWS_DEFAULT_REGION,
      signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = { Bucket: AWS_BUCKET, Key: value.company_logo };
    var user_iamge = s3.getSignedUrl('getObject', params);
  }


  const viewFile = (link) => {
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
      accessKeyId: AWS_ACCESS_KEY_ID,
      secretAccessKey: AWS_SECRET_ACCESS_KEY,
      region: AWS_DEFAULT_REGION,
      signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = { Bucket: AWS_BUCKET, Key: link };
    return s3.getSignedUrl('getObject', params);
  }
  const editItem = () => {
    window.location.href = "/customers-edit/" + id;
  }
  const customerPortal = () => {

    localStorage.setItem("customer_id", id);
    localStorage.setItem("profile_image", value.company_logo);
    localStorage.setItem("user_type", 'portal_user');
    localStorage.setItem("customer_info", JSON.stringify(value));
    var customer_menu =[
    {
        "module_id": 1,
        "parent_page_id": 0,
        "name": "Dashboard",
        "slug": "/customerportal/index",
        "icon": "home",
        "inner": []
    },
    {
        "module_id": 2,
        "parent_page_id": 0,
        "name": "Orders",
        "slug": "/customerportal/orders",
        "icon": null,
        "inner": []
    },
    {
        "module_id": 3,
        "parent_page_id": 0,
        "name": "Packing Sites",
        "slug": "/customerportal/packing-sites",
        "icon": null,
        "inner": []
    },
    {
        "module_id": 4,
        "parent_page_id": 0,
        "name": "Farms",
        "slug": "/customerportal/farms",
        "icon": null,
        "inner": []
    },
    {
        "module_id": 5,
        "parent_page_id": 0,
        "name": "Quality Reports",
        "slug": "/customerportal/quality-reports",
        "icon": null,
        "inner": []
    },
    {
        "module_id": 6,
        "parent_page_id": 0,
        "name": "Invoice and Payments",
        "slug": "/customerportal/invoices-payments",
        "icon": null,
        "inner": []
    },
    {
        "module_id": 7,
        "parent_page_id": 0,
        "name": "Loadings",
        "slug": "/customerportal/loadings",
        "icon": null,
        "inner": []
    },
    {
        "module_id": 8,
        "parent_page_id": 0,
        "name": "Contacts",
        "slug": "/customerportal/contacts",
        "icon": null,
        "inner": []
    }
];

    localStorage.setItem("customer_menu", JSON.stringify(customer_menu));
    window.location.href = "/customerportal/index";
  }

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Customers</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/customers">Customers</Link>
                    </li>
                    <li className="breadcrumb-item active">View Customer</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="card">
                  {permission?.list == 1 && (
                    <div className="card-body">

                      {/* Header */}
                      <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
                        <h4 className="card-title mb-0">View Customer Information</h4>
                        <div>
                          <button onClick={() => customerPortal()} className="btn btn-danger" style={{ }}>
                            Customer Portal
                          </button> 
                           &nbsp;&nbsp; &nbsp;&nbsp;
                          <button onClick={() => editItem()} className="btn btn-danger" style={{ float: 'right' }}>
                            Edit
                          </button>
                        </div>

                      </div>

                      {/* ── Company Info ── */}
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <tbody>
                            <tr>
                              <th className="p-3 text-nowrap" style={{ width: "30%" }}>Company Logo</th>
                              <td className="p-3">
                                <img
                                  className="avatar-img"
                                  src={user_iamge}
                                  alt="Profile Image"
                                  style={{ width: "120px", height: "120px", objectFit: "contain" }}
                                />
                              </td>
                            </tr>
                            <tr>
                              <th className="p-3 text-nowrap">Company Name</th>
                              <td className="p-3">{value.company_name}</td>
                            </tr>
                            <tr>
                              <th className="p-3 text-nowrap">Company Phone</th>
                              <td className="p-3">{value.company_phone}</td>
                            </tr>
                            <tr>
                              <th className="p-3 text-nowrap">Company Website</th>
                              <td className="p-3">{value.company_website}</td>
                            </tr>
                            <tr>
                              <th className="p-3 text-nowrap">Company Email</th>
                              <td className="p-3">{value.company_email}</td>
                            </tr>
                            <tr>
                              <th className="p-3 text-nowrap">Select Currency</th>
                              <td className="p-3">
                                {value.company_primary_currency ? value.currency.title : ""}
                              </td>
                            </tr>
                            <tr>
                              <th className="p-3 text-nowrap">Incoterms</th>
                              <td className="p-3">
                                {value.incoterm ? value.incoterm_name.title : ""}
                              </td>
                            </tr>
                            <tr>
                              <th className="p-3 text-nowrap">Payment Term</th>
                              <td className="p-3">
                                {value.payment_term ? value.payment_terms.name : ""}
                              </td>
                            </tr>
                            <tr>
                              <th className="p-3 text-nowrap">VAT</th>
                              <td className="p-3">{value.vat}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      {/* ── Addresses ── */}
                      <h5 className="card-title mt-4 mb-3">Addresses</h5>
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <thead className="table-light">
                            <tr>
                              <th className="p-3 text-nowrap">Address Type</th>
                              <th className="p-3 text-nowrap">Name</th>
                              <th className="p-3 text-nowrap">Email</th>
                              <th className="p-3 text-nowrap">Phone Number</th>
                              <th className="p-3 text-nowrap">Street</th>
                              <th className="p-3 text-nowrap">City</th>
                              <th className="p-3 text-nowrap">Zip Code</th>
                              <th className="p-3 text-nowrap">Country</th>
                            </tr>
                          </thead>
                          <tbody>
                            {value.addresses &&
                              value.addresses.map((item, index) => (
                                <tr key={item.id || index}>
                                  <td className="p-3">{item.add_type}</td>
                                  <td className="p-3">{item.name}</td>
                                  <td className="p-3">{item.email}</td>
                                  <td className="p-3">{item.phone_number}</td>
                                  <td className="p-3">{item.street}</td>
                                  <td className="p-3">{item.city}</td>
                                  <td className="p-3">{item.zip_code}</td>
                                  <td className="p-3">{item.country_name}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>

                      {/* ── Brokers ── */}
                      <h5 className="card-title mt-4 mb-3">Brokers</h5>
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <thead className="table-light">
                            <tr>
                              <th className="p-3 text-nowrap">Name</th>
                              <th className="p-3 text-nowrap">Phone Number</th>
                              <th className="p-3 text-nowrap">Email</th>
                              <th className="p-3 text-nowrap">CO Code</th>
                              <th className="p-3 text-nowrap">Phyto Type</th>
                              <th className="p-3 text-nowrap">Address</th>
                            </tr>
                          </thead>
                          <tbody>
                            {value.brokers &&
                              value.brokers.map((broker, index) => (
                                <tr key={broker.id || index}>
                                  <td className="p-3">{broker.broker_name}</td>
                                  <td className="p-3">{broker.broker_phone_number}</td>
                                  <td className="p-3">{broker.broker_email}</td>
                                  <td className="p-3">{broker.broker_co_code}</td>
                                  <td className="p-3">{broker.broker_phyto_type_title ?? ""}</td>
                                  <td className="p-3">{broker.broker_address}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>

                      {/* ── Contacts ── */}
                      <h5 className="card-title mt-4 mb-3">Contacts</h5>
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <thead className="table-light">
                            <tr>
                              <th className="p-3 text-nowrap">First Name</th>
                              <th className="p-3 text-nowrap">Last Name</th>
                              <th className="p-3 text-nowrap">Email</th>
                              <th className="p-3 text-nowrap">Phone Number</th>
                              <th className="p-3 text-nowrap">Function</th>
                            </tr>
                          </thead>
                          <tbody>
                            {value.contacts &&
                              value.contacts.map((contact, index) => (
                                <tr key={contact.id || index}>
                                  <td className="p-3">{contact.contact_first_name}</td>
                                  <td className="p-3">{contact.contact_last_name}</td>
                                  <td className="p-3">{contact.contact_email}</td>
                                  <td className="p-3">{contact.contact_phone_number}</td>
                                  <td className="p-3">{contact.contact_function}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>

                      {/* ── Contract Documents ── */}
                      <h5 className="card-title mt-4 mb-3">Contract Documents</h5>
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <thead className="table-light">
                            <tr>
                              <th className="p-3 text-nowrap">Document Name</th>
                              <th className="p-3 text-nowrap">Document Type</th>
                              <th className="p-3 text-nowrap">Document Attached</th>
                            </tr>
                          </thead>
                          <tbody>
                            {value.customer_contract_documents &&
                              value.customer_contract_documents.map((doc, index) => (
                                <tr key={doc.id || index}>
                                  <td className="p-3">{doc.file_name}</td>
                                  <td className="p-3">{doc.file_type_name}</td>
                                  <td className="p-3">
                                    {doc.link && (
                                      <a
                                        className="btn btn-primary btn-sm"
                                        href={viewFile(doc.link)}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        download
                                      >
                                        <i className="fa fa-download me-1"></i> Download
                                      </a>
                                    )}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>

                      {/* ── Customer Farms ── */}
                      <h5 className="card-title mt-4 mb-3">Customer Farms</h5>
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <thead className="table-light">
                            <tr>
                              <th className="p-3 text-nowrap">Farm Name</th>
                              <th className="p-3 text-nowrap">Location</th>
                              <th className="p-3 text-nowrap">GGN Number</th>
                              <th className="p-3 text-nowrap">Farm Size</th>
                              <th className="p-3 text-nowrap">Estimated Crops</th>
                            </tr>
                          </thead>
                          <tbody>
                            {value.customer_farms &&
                              value.customer_farms.map((farm, index) => (
                                <tr key={farm.id || index}>
                                  <td className="p-3">{farm.name}</td>
                                  <td className="p-3">{farm.location}</td>
                                  <td className="p-3">{farm.ggn_number}</td>
                                  <td className="p-3">{farm.farm_size}</td>
                                  <td className="p-3">{farm.estimated_crops}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>

                      {/* ── Processing Lines ── */}
                      <h5 className="card-title mt-4 mb-3">Processing Lines</h5>
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <thead className="table-light">
                            <tr>
                              <th className="p-3 text-nowrap">Location</th>
                              <th className="p-3 text-nowrap">GPS Location</th>
                              <th className="p-3 text-nowrap">Description</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Array.isArray(value.customer_locations) &&
                              value.customer_locations
                                .filter(location => location)
                                .map((location, index) => (
                                  <tr key={location.id || index}>
                                    <td className="p-3">{location.title || "N/A"}</td>
                                    <td className="p-3">{location.gps_location || "N/A"}</td>
                                    <td className="p-3">{location.description || "N/A"}</td>
                                  </tr>
                                ))}
                          </tbody>
                        </table>
                      </div>

                      {/* ── Users ── */}
                      <h5 className="card-title mt-4 mb-3">Users</h5>
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <thead className="table-light">
                            <tr>
                              <th className="p-3 text-nowrap">First Name</th>
                              <th className="p-3 text-nowrap">Last Name</th>
                              <th className="p-3 text-nowrap">Email</th>
                              <th className="p-3 text-nowrap">Function</th>
                              <th className="p-3 text-nowrap">User Type</th>
                            </tr>
                          </thead>
                          <tbody>
                            {value.users &&
                              value.users.map((user, index) => (
                                <tr key={user.id || index}>
                                  <td className="p-3">{user.user_first_name}</td>
                                  <td className="p-3">{user.user_last_name}</td>
                                  <td className="p-3">{user.user_email}</td>
                                  <td className="p-3">{user.user_function}</td>
                                  <td className="p-3">
                                    {user.user_type === 1
                                      ? "Administrator"
                                      : user.user_type === 2
                                        ? "Standard"
                                        : "Unknown"}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>

                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ViewCustomer;
